/**
 * @generated SignedSource<<d664a2be5310dffc25d9b1a335fe17f9>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "SelectUserLoginPayload",
            "kind": "LinkedField",
            "name": "selectUserLogin",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "token",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshToken",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SelectUser_selectUserLoginMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SelectUser_selectUserLoginMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "a97e2cc911719ee004432ad2e4063bab",
            "id": null,
            "metadata": {},
            "name": "SelectUser_selectUserLoginMutation",
            "operationKind": "mutation",
            "text": "mutation SelectUser_selectUserLoginMutation(\n  $model: SelectUserLoginInput!\n) {\n  selectUserLogin(model: $model) {\n    token\n    refreshToken\n  }\n}\n"
        }
    };
})();
node.hash = "5fb07b01fc4d2c265dedc40adc7b8228";
export default node;
